import { getDeviceInfo, deviceInfo } from './detection'

export { getDeviceInfo, deviceInfo }
